import { createContext, useContext } from 'react'

export type Roles = 'providers' | 'patients' | 'general' | 'sysadmin'

interface RoleProvider {
  role: Roles
}

const defaultValue: RoleProvider = {
  role: 'general',
}

const RootContext = createContext<RoleProvider>(defaultValue)
export const useRoot = () => useContext(RootContext)
export default RootContext
